import {z} from "zod";

export const signupUsernameSchema = z.object({
    username: z.string().regex(/^09\d{9}$/, "نام کاربری معتبر نیست"),
});

export const signupOTPSchema = z.object({
        username: z.string().regex(/^09\d{9}$/, "نام کاربری معتبر نیست"),
        code: z
            .string()
            .length(6, "کد باید 6 رقم باشد")
            .regex(/^\d+$/, "کد نامعتبر است"),
        password: z
            .string()
            .min(8, {
                message:
                    "رمز عبور باید شامل حداقل 8 کاراکتر، یک حرف کوچک، یک حرف بزرگ، یک عدد و یک کاراکتر خاص باشد",
            })
            .superRefine((value, ctx) => {
                if (!/[a-z]/.test(value)) {
                    ctx.addIssue({
                        code: z.ZodIssueCode.custom,
                        message:
                            "رمز عبور باید شامل حداقل 8 کاراکتر، یک حرف کوچک، یک حرف بزرگ، یک عدد و یک کاراکتر خاص باشد",
                    });
                }
                if (!/[A-Z]/.test(value)) {
                    ctx.addIssue({
                        code: z.ZodIssueCode.custom,
                        message:
                            "رمز عبور باید شامل حداقل 8 کاراکتر، یک حرف کوچک، یک حرف بزرگ، یک عدد و یک کاراکتر خاص باشد",
                    });
                }
                if (!/[0-9]/.test(value)) {
                    ctx.addIssue({
                        code: z.ZodIssueCode.custom,
                        message:
                            "رمز عبور باید شامل حداقل 8 کاراکتر، یک حرف کوچک، یک حرف بزرگ، یک عدد و یک کاراکتر خاص باشد",
                    });
                }
                if (!/[^a-zA-Z0-9]/.test(value)) {
                    ctx.addIssue({
                        code: z.ZodIssueCode.custom,
                        message:
                            "رمز عبور باید شامل حداقل 8 کاراکتر، یک حرف کوچک، یک حرف بزرگ، یک عدد و یک کاراکتر خاص باشد",
                    });
                }
            }),
        confirmPassword: z.string(),
    })
    .refine((data) => data.password === data.confirmPassword, {
        message: "رمز عبور و تکرار رمز عبور باید یکسان باشند",
        path: ["confirmPassword"],
    });

export const addTicketSchema = z.object({
    unit: z.coerce.string().min(1, "انتخاب بخش الزامی است"),
    feature: z.coerce.string().min(1, "انتخاب ویژگی الزامی است"),
    title: z.string().min(1, "عنوان تیکت الزامی است"),
    text: z.string().min(1, "توضیحات تیکت الزامی است"),
});

export const replyTicketSchema = z.object({
    description: z.string().min(1, "توضیحات تیکت الزامی است"),
});

export const profileEmailSchema = z.object({
    email: z.string().email("ایمیل وارد شده معتبر نمی باشد"),
});

export const profilePersonalInfoSchema = z.object({
    first_name: z
        .string()
        .min(1, "نام الزامی است")
        .regex(/^[\u0600-\u06FF\s]+$/, "نام باید فقط شامل حروف فارسی باشد"),
    last_name: z
        .string()
        .min(1, "نام خانوادگی الزامی است")
        .regex(
            /^[\u0600-\u06FF\s]+$/,
            "نام خانوادگی باید فقط شامل حروف فارسی باشد"
        ),
});

export const profilePasswordSchema = z.object({
        old_password: z.string().min(1, "رمز عبور فعلی الزامی است"),
        new_password: z
            .string()
            .regex(
                /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[!@#$%^&*(),.?":{}|<>]).{8,}$/,
                "رمز عبور باید حداقل ۸ کاراکتر بوده و شامل یک حرف بزرگ، یک حرف کوچک، یک عدد و یک کاراکتر ویژه باشد"
            ),
        confirm_password: z.string(),
    })
    .refine((data) => data.new_password === data.confirm_password, {
        message: "رمز عبور و تکرار آن باید یکسان باشد",
        path: ["confirm_new_password"],
    })
    .refine((data) => data.old_password !== data.new_password, {
        message: "رمز عبور قدیمی و جدید نمی‌تواند یکسان باشد",
        path: ["new_password"],
    });